<template>
  <div class="p-10">
    <van-notice-bar scrollable
                    text="输入客户名称时，下方匹配出的客户代表本系统已存在，无需再录入。"/>
    <van-form ref="form" :show-error="false" error-message-align="right">
      <van-cell-group>
        <van-field v-model="formData.companyName" label="客户名称" name="companyName" input-align="right" readonly
                    required
                   :rules="[{ required: true, message: '请输入客户名称' }]">
          <template #input>
            <el-autocomplete size="mini" style="width: 100%" filterable v-model="formData.companyName"
                             :fetch-suggestions="querySearch"
                             placeholder="请输入客户名称"/>
          </template>
        </van-field>
        <van-field input-align="right" name="parentId" :value="formData.parentId" label="上级单位"
                   placeholder="请选择上级单位">
          <template #input>
            <form-view-item @click.native="parentId.show = true" :value="formData.parentId" placeholder="请选择上级单位"
                            :options="{data:parentId.data,showFields:'companyName',valueKey:'id'}"/>
            <van-popup v-model="parentId.show" position="bottom">
              <van-nav-bar title="选择上级单位" left-text="取消" right-text="确定" @click-left="parentId.show = false"
                           @click-right="popupSubmit('parentId',{value:'id'})"/>
              <van-search v-model="parentId.filterText" @input="pickerSearch($event,parentId,'companyName')" clearable
                          shape="round"/>
              <van-picker ref="parentId" value-key="companyName" :columns="parentId.filteredData"
                          @cancel="parentId.show = false"/>
            </van-popup>
          </template>
        </van-field>


        <van-field input-align="right" name="companyLevel" :value="formData.companyLevel" label="客户级别"
                   required :rules="[{ required: true, message: '请选择客户级别' }]" placeholder="请选择客户级别">
          <template #input>
            <form-view-item @click.native="companyLevel.show = true" :value="formData.companyLevel"
                            placeholder="请选择客户级别"
                            :options="{data:companyLevel.data,showFields:'dictLabel',valueKey:'dictValue'}"/>
            <van-popup v-model="companyLevel.show" position="bottom">
              <van-nav-bar title="选择客户级别" left-text="取消" right-text="确定"
                           @click-left="companyLevel.show = false"
                           @click-right="popupSubmit('companyLevel',{value:'dictValue'})"/>
              <van-search v-model="companyLevel.filterText" @input="pickerSearch($event,companyLevel,'dictLabel')"
                          clearable
                          shape="round"/>
              <van-picker ref="companyLevel" value-key="dictLabel" :columns="companyLevel.filteredData"
                          @cancel="companyLevel.show = false"/>
            </van-popup>
          </template>
        </van-field>

        <van-field input-align="right" name="companyNature" :value="formData.companyNature" label="单位类型"
                   required :rules="[{ required: true, message: '请选择单位类型' }]" placeholder="请选择单位类型">
          <template #input>
            <form-view-item @click.native="companyNature.show = true" :value="formData.companyNature"
                            placeholder="请选择单位类型"
                            :options="{data:companyNature.data,showFields:'dictLabel',valueKey:'dictValue'}"/>
            <van-popup v-model="companyNature.show" position="bottom">
              <van-nav-bar title="选择单位类型" left-text="取消" right-text="确定"
                           @click-left="companyNature.show = false"
                           @click-right="popupSubmit('companyNature',{value:'dictValue'})"/>
              <van-search v-model="companyNature.filterText" @input="pickerSearch($event,companyNature,'dictLabel')"
                          clearable
                          shape="round"/>
              <van-picker ref="companyNature" value-key="dictLabel" :columns="companyNature.filteredData"
                          @cancel="companyNature.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field input-align="right" name="customBase" :value="formData.customBase" label="客户规模"
                   required :rules="[{ required: true, message: '请选择客户规模' }]" placeholder="请选择客户规模">
          <template #input>
            <form-view-item @click.native="customBase.show = true" :value="formData.customBase"
                            placeholder="请选择客户规模"
                            :options="{data:customBase.data,showFields:'dictLabel',valueKey:'dictValue'}"/>
            <van-popup v-model="customBase.show" position="bottom">
              <van-nav-bar title="选择客户规模" left-text="取消" right-text="确定"
                           @click-left="customBase.show = false"
                           @click-right="popupSubmit('customBase',{value:'dictValue'})"/>
              <van-search v-model="customBase.filterText" @input="pickerSearch($event,customBase,'dictLabel')"
                          clearable
                          shape="round"/>
              <van-picker ref="customBase" value-key="dictLabel" :columns="customBase.filteredData"
                          @cancel="customBase.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field input-align="right" name="companyIndustry" :value="formData.companyIndustry" label="行业"
                   required :rules="[{ required: true, message: '请选择行业' }]" placeholder="请选择行业">
          <template #input>
            <form-view-item @click.native="companyIndustry.show = true" :value="formData.companyIndustry"
                            placeholder="请选择行业"
                            :options="{data:companyIndustry.data,showFields:'dictLabel',valueKey:'dictValue'}"/>
            <van-popup v-model="companyIndustry.show" position="bottom">
              <van-nav-bar title="选择行业" left-text="取消" right-text="确定"
                           @click-left="companyIndustry.show = false"
                           @click-right="popupSubmit('companyIndustry',{value:'dictValue'})"/>
              <van-search v-model="companyIndustry.filterText" @input="pickerSearch($event,companyIndustry,'dictLabel')"
                          clearable
                          shape="round"/>
              <van-picker ref="companyIndustry" value-key="dictLabel" :columns="companyIndustry.filteredData"
                          @cancel="companyIndustry.show = false"/>
            </van-popup>
          </template>
        </van-field>

        <van-field input-align="right" name="companySource" :value="formData.companySource" label="客户来源"
                   placeholder="请选择客户来源">
          <template #input>
            <form-view-item @click.native="companySource.show = true" :value="formData.companySource"
                            placeholder="请选择客户来源"
                            :options="{data:companySource.data,showFields:'dictLabel',valueKey:'dictValue'}"/>
            <van-popup v-model="companySource.show" position="bottom">
              <van-nav-bar title="选择客户来源" left-text="取消" right-text="确定"
                           @click-left="companySource.show = false"
                           @click-right="popupSubmit('companySource',{value:'dictValue'})"/>
              <van-search v-model="companySource.filterText" @input="pickerSearch($event,companySource,'dictLabel')"
                          clearable
                          shape="round"/>
              <van-picker ref="companySource" value-key="dictLabel" :columns="companySource.filteredData"
                          @cancel="companySource.show = false"/>
            </van-popup>
          </template>
        </van-field>

        <van-field input-align="right" name="companyEntrustType" :value="formData.companyEntrustType"
                   label="业务委托形式"
                   placeholder="请选择业务委托形式">
          <template #input>
            <form-view-item @click.native="companyEntrustType.show = true" :value="formData.companyEntrustType"
                            placeholder="请选择业务委托形式"
                            :options="{data:companyEntrustType.data,showFields:'dictLabel',valueKey:'dictValue'}"/>
            <van-popup v-model="companyEntrustType.show" position="bottom">
              <van-nav-bar title="选择业务委托形式" left-text="取消" right-text="确定"
                           @click-left="companyEntrustType.show = false"
                           @click-right="popupSubmit('companyEntrustType',{value:'dictValue'})"/>
              <van-search v-model="companyEntrustType.filterText"
                          @input="pickerSearch($event,companyEntrustType,'dictLabel')"
                          clearable
                          shape="round"/>
              <van-picker ref="companyEntrustType" value-key="dictLabel" :columns="companyEntrustType.filteredData"
                          @cancel="companyEntrustType.show = false"/>
            </van-popup>
          </template>
        </van-field>


        <van-field v-model="formData.companyLegalPerson" name="companyLegalPerson" maxlength="50" autosize label="法人"
                   placeholder="请输入法人" input-align="right"/>
        <van-field v-model="formData.companyTelephone" name="companyTelephone" maxlength="50" autosize label="联系电话"
                   placeholder="请输入联系电话" input-align="right"/>


        <van-field input-align="right" name="companyProvince" :value="formData.companyProvince"
                   required :rules="[{ required: true, message: '请选择省份/直辖市' }]" label="省份/直辖市"
                   placeholder="请选择省份/直辖市">
          <template #input>
            <form-view-item @click.native="companyProvince.show = true" :value="formData.companyProvince"
                            placeholder="请选择省份/直辖市"
                            :options="{data:companyProvince.data,showFields:'label',valueKey:'value'}"/>
            <van-popup v-model="companyProvince.show" position="bottom">
              <van-nav-bar title="选择省份/直辖市" left-text="取消" right-text="确定"
                           @click-left="companyProvince.show = false"
                           @click-right="companyProvincePopupSubmit('companyProvince',{value:'value'})"/>
              <van-search v-model="companyProvince.filterText"
                          @input="pickerSearch($event,companyProvince,'label')"
                          clearable
                          shape="round"/>
              <van-picker ref="companyProvince" value-key="label" :columns="companyProvince.filteredData"
                          @cancel="companyProvince.show = false"/>
            </van-popup>
          </template>
        </van-field>

        <van-field input-align="right" name="companyCity" :value="formData.companyCity"
                   :label="(formData.companyProvince!='110000'&&formData.companyProvince!='120000'&&formData.companyProvince!='500000'&&formData.companyProvince!='310000')?'市':'区'"
                   placeholder="请选择省份/直辖市">
          <template #input>
            <form-view-item @click.native="companyCity.show = true" :value="formData.companyCity"
                            :placeholder="`请选择${(formData.companyProvince!='110000'&&formData.companyProvince!='120000'&&formData.companyProvince!='500000'&&formData.companyProvince!='310000')?'市':'区'}`"
                            :options="{data:companyCity.data,showFields:'label',valueKey:'value'}"/>
            <van-popup v-model="companyCity.show" position="bottom">
              <van-nav-bar
                  :title="`选择${(formData.companyProvince!='110000'&&formData.companyProvince!='120000'&&formData.companyProvince!='500000'&&formData.companyProvince!='310000')?'市':'区'}`"
                  left-text="取消" right-text="确定"
                  @click-left="companyCity.show = false"
                  @click-right="companyCityPopupSubmit('companyCity',{value:'value'})"/>
              <van-search v-model="companyCity.filterText"
                          @input="pickerSearch($event,companyCity,'label')"
                          clearable
                          shape="round"/>
              <van-picker ref="companyCity" value-key="label" :columns="companyCity.filteredData"
                          @cancel="companyCity.show = false"/>
            </van-popup>
          </template>
        </van-field>

        <van-field
            v-if="formData.companyProvince!='110000'&&formData.companyProvince!='120000'&&formData.companyProvince!='500000'&&formData.companyProvince!='310000'"
            input-align="right" name="companyArea" :value="formData.companyArea"
            label="旗/县/区"
            placeholder="请选择旗/县/区">
          <template #input>
            <form-view-item @click.native="companyArea.show = true" :value="formData.companyArea"
                            placeholder="请选择旗/县/区"
                            :options="{data:companyArea.data,showFields:'label',valueKey:'value'}"/>
            <van-popup v-model="companyArea.show" position="bottom">
              <van-nav-bar title="选择旗/县/区" left-text="取消" right-text="确定"
                           @click-left="companyArea.show = false"
                           @click-right="popupSubmit('companyArea',{value:'value'})"/>
              <van-search v-model="companyArea.filterText"
                          @input="pickerSearch($event,companyArea,'label')"
                          clearable
                          shape="round"/>
              <van-picker ref="companyArea" value-key="label" :columns="companyArea.filteredData"
                          @cancel="companyArea.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-model="formData.companyPlace" name="companyPlace" maxlength="50" autosize label="详细地址"
                   placeholder="请输入详细地址" input-align="right"/>
        <van-field input-align="right" name="companyProvince" :value="formData.companyProvince"
                   label="所属部门"
                   placeholder="请选择所属部门">
          <template #input>
            <form-view-item :isShowIcon="false" :value="formData.deptId" placeholder="请选择所属部门"
                            :options="{data:jurisdictionDeptTree,showFields:'label',valueKey:'value',childrenKey:'children'}"/>
          </template>
        </van-field>
        <van-field v-model="formData.companyIntroduce" name="companyIntroduce" type="textarea" maxlength="200" rows="3"
                   autosize label="客户简介" show-word-limit placeholder="请输入客户简介" input-align="right"/>
        <van-field v-model="formData.remark" name="remark" type="textarea" maxlength="200" rows="3" autosize
                   label="备注" show-word-limit placeholder="请输入备注" input-align="right"/>
      </van-cell-group>
    </van-form>

    <div class="bottom-bar-placeholder">
      <div class="bottom-bar flex">
        <div class="btn-item flex-1 bg-FFDB43" @click="submit(0)">
          {{ '确定' }}
        </div>
        <div class="btn-item flex-2 bg-FFDB43" @click="submit(1)">
          {{ '保存并录入联系人' }}
        </div>
        <div class="btn-item flex-1 bg-FF" @click="goBack">
          {{ '返回' }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {area, city, companyList, province, company} from '@/api/crm/index'
import mixin from '@/mixin/default-form'
import formViewItem from "@/components/formViewItem/index.vue";
import {getDictDataByType} from "@/api/dict";
import titleBar from "@/components/title-bar.vue";
import uploadFiles from "@/components/uploadFiles/index.vue";
import {jurisdictionDeptTree} from "@/api/dept";
import cache from "@/plugins/cache";

class PickerOptions {
  constructor() {
    this.data = [];
    this.show = false;
    this.filteredData = [];
    this.filterText = '';
  }
}

export default {
  mixins: [mixin],
  components: {uploadFiles, titleBar, formViewItem},
  data() {
    return {
      parentId: new PickerOptions(),
      companyLevel: new PickerOptions(),
      customBase: new PickerOptions(),
      companyNature: new PickerOptions(),
      companyIndustry: new PickerOptions(),
      companySource: new PickerOptions(),
      companyEntrustType: new PickerOptions(),
      companyProvince: new PickerOptions(),
      companyCity: new PickerOptions(),
      companyArea: new PickerOptions(),
      // 部门树
      jurisdictionDeptTree: [],
      // 新增  客户管理数据
      parentCompanyList: [],
      //客户名称提示
      restaurants: [],
      formData: {
        companyLegalPerson: '',
        // 上级单位
        parentId: '',
        // 客户级别
        companyLevel: '',
        // 客户规模
        customBase:'',
        // 单位类型
        companyNature: '',
        // 行业
        companyIndustry: '',
        // 客户来源
        companySource: '',
        // 省/直辖市
        companyProvince: '',
        // 市：区
        companyCity: '',
        // 旗县区
        companyArea: '',
        // 详细地址
        companyPlace: '',
        // 所属部门
        deptId: '',
        // 客户简介
        companyIntroduce: '',
        // 备注
        remark: ''
      }
    }
  },
  created() {
    this.formData.deptId = JSON.parse(cache.session.get('userInfo'))?.deptId
    getDictDataByType('customer_level').then(res => {
      this.companyLevel.data = res.data
      this.companyLevel.filteredData = res.data
    })
     getDictDataByType('custom_base').then(res => {
      this.customBase.data = res.data
      this.customBase.filteredData = res.data
    })
    getDictDataByType('customer_nature').then(res => {
      this.companyNature.data = res.data
      this.companyNature.filteredData = res.data
    })
    getDictDataByType('customer_industry').then(res => {
      this.companyIndustry.data = res.data
      this.companyIndustry.filteredData = res.data
    })
    getDictDataByType('company_source').then(res => {
      this.companySource.data = res.data
      this.companySource.filteredData = res.data
    })
    getDictDataByType('company_entrust_type').then(res => {
      this.companyEntrustType.data = res.data
      this.companyEntrustType.filteredData = res.data
    })
    province().then(res => {
      this.companyProvince.data = res.rows
      this.companyProvince.filteredData = res.rows
    })
    jurisdictionDeptTree().then(res => {
      this.jurisdictionDeptTree = res.data
    })

    this.getParentCompanyList()
  },
  methods: {
    submit(isPerson) {
      const submit = company
      console.log(this.formData)
      // 校验
      this.$refs.form.validate().then(() => {
        this.$loading.show()
        submit(this.formData).then(res => {
          this.$loading.hide()
          this.$toast(res.msg, {duration: 500})
          setTimeout(() => {
            isPerson ? this.goAddCustomer(res.data.id) : this.goBack()
          }, 500)
        })
      })
    },
    goAddCustomer(companyId) {
      this.$router.push({path: '/customer/add', query: {companyId}})
    },
    goBack() {
      this.$router.push({path: '/client'})
    },
    companyProvincePopupSubmit(field, props) {
      const item = this.$refs[field].getValues()[0]
      this.$set(this[field], 'show', false)
      this.$set(this.formData, field, item[props.value])
      city({provinceId: item.value}).then(res => {
        this.companyCity.data = res.rows
        this.companyCity.filteredData = res.rows
      })
    },
    companyCityPopupSubmit(field, props) {
      const item = this.$refs[field].getValues()[0]
      this.$set(this[field], 'show', false)
      this.$set(this.formData, field, item[props.value])
      area({cityId: item.value}).then(res => {
        this.companyArea.data = res.rows
        this.companyArea.filteredData = res.rows
      })
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
      };
    },
    getParentCompanyList() {
      this.restaurants = [];
      var queryParam = {
        pageNum: 1,
        pageSize: 10000,
      };
      companyList(queryParam).then(response => {
        this.parentId.data = response.rows;
        this.parentId.filteredData = response.rows;
        if (response.rows.length > 0) {
          response.rows.forEach(item => {
            this.restaurants.push({
              'value': item.companyName
            });
          })
        }
      });
    },
  }
}

</script>
<style lang="less" scoped>

</style>
